import { CircleHelp } from "lucide-react";

type FormFieldTooltipProps = {
  content: string;
};

function FormFieldTooltip({ content }: FormFieldTooltipProps) {
  return (
    <span
      className="group relative ml-1 inline-flex cursor-help align-middle"
      tabIndex={0}
      aria-label={content}
    >
      <CircleHelp className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-0 z-50 mb-2 w-72 rounded-md border bg-popover px-3 py-2 text-xs font-normal leading-relaxed text-popover-foreground opacity-0 shadow-md transition-opacity group-hover:opacity-100 group-focus:opacity-100"
      >
        {content}
      </span>
    </span>
  );
}

export default FormFieldTooltip;
